export default {"src":"/_next/static/media/pay_online.f71440c4.svg","height":535,"width":888};